// Components==============
import { motion } from 'framer-motion';
import { useTranslate } from 'hooks/useTranslate';
import React, { useEffect, useRef, useState } from 'react';
import { interactiveScale } from 'utilities/FramerAnimations';
import { getColorProfileSize } from 'utilities/getColorProfileSize';
import './ColorProfile.module.scss';
// =========================

const framerChild = {
  initial: {
    x: '-50%',
    y: '-50%',
    scale: 0,
  },
  animate: {
    x: '-50%',
    y: '-50%',
    scale: 1,
  },
};

const Phase = ({
  bounds,
  data,
  index,
}: {
  bounds: React.RefObject<HTMLDivElement>;
  data: {
    name: string;
    percentage: number;
  };
  index: number;
}) => {
  const [position, setPosition] = useState({
    top: 0,
    left: 0,
  });

  useEffect(() => {
    if (bounds.current)
      setPosition({
        top: Math.round(Math.random() * bounds.current.clientWidth),
        left: Math.round(Math.random() * bounds.current.clientHeight),
      });
  }, []);

  return (
    <motion.div
      variants={framerChild}
      styleName={`phase ${data.name}`}
      style={{
        width: getColorProfileSize(data.percentage, index),
        height: getColorProfileSize(data.percentage, index),
        top: index === 0 ? '50%' : position.top,
        left: index === 0 ? '50%' : position.left,
      }}
      custom={index}
    />
  );
};

export default function ColorProfile({
  data,
  onClick,
  delay,
}: {
  data: {
    name: string;
    percentage: number;
  }[];
  onClick?: () => void;
  delay?: boolean;
}) {
  const translate = useTranslate();
  const bounds = useRef<HTMLDivElement>(null);

  const framerParent = {
    ...interactiveScale,
    animate: {
      transition: { staggerChildren: 0.1, delayChildren: delay ? 0.5 : 0 },
    },
  };

  return (
    <div styleName="wrapper ">
      <motion.div
        styleName="color-profile "
        ref={bounds}
        variants={framerParent}
        whileHover="whileHover"
        initial="initial"
        whileTap="whileTap"
        animate="animate"
        onClick={onClick}
      >
        <h2>{translate('reflection.terms.my-color-profile')}</h2>
        {data
          .sort((a, b) => b.percentage - a.percentage)
          .map((d, i) => (
            <Phase key={d.name} data={d} bounds={bounds} index={i} />
          ))}
      </motion.div>
    </div>
  );
}
